import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import UserService from "../services/user.service";
import CatalogService from "../services/catalog.service";
import Carousel from "react-bootstrap/Carousel";
import Card from "react-bootstrap/Card";
import Spinner from "react-bootstrap/Spinner";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import ImageGallery from './ImageGallery';
import { resolveImageUrl, resolveSwatchUrl } from '../utils/imageUrl';

import ButtonGroup from "react-bootstrap/ButtonGroup";
import { selectCatalogItem, getCatalogItem, selectDecorations, selectInventory, selectQuantityPrices, selectUserCapability } from '../reducers/catalog';
import { addItemToOrder, cartCount, toggleShowCart, cart, updateItemQuantity } from '../reducers/cart';
import { isLoggedIn, getSubsite, getUser, getSubsiteBalance } from '../reducers/auth';
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { Container, Row, Col, Modal, Alert } from 'react-bootstrap';

const PRICING_TYPES = {
  FLAT: 1,
  QUANTITY: 2,
  BILL_LATER: 3
};

const ProductDetails = () => {
  const apiUrl = process.env.REACT_APP_LOCALHOST_URL;
  const { productId } = useParams();
  const dispatch = useDispatch();
  const catalogItem = useSelector(selectCatalogItem);
  const currentSubsite = useSelector(getSubsite);
  const currentSubsiteBalance = useSelector(getSubsiteBalance);
  const inventory = useSelector(selectInventory);
  const quantityPrices = useSelector(selectQuantityPrices);
  const cartCountValue = useSelector(cartCount);
  const itemStatus = useSelector(state => state.catalog.itemStatus)
  const userCapability = useSelector(selectUserCapability);
  const [imgSrc, setImgSrc] = useState(null);
  const [logoSrc, setLogoSrc] = useState("");
  const [imgSrcBack, setImgSrcBack] = useState(null);
  const [currentItem, setCurrentItem] = useState(null);
  const [currentColor, setCurrentColor] = useState(null);
  const [currentImages, setCurrentImages] = useState(null);
  const [currentImage, setCurrentImage] = useState(null);
  const [currentSize, setCurrentSize] = useState(null);
  const [currentPrice, setCurrentPrice] = useState(null);
  const [currentLogoPrice, setCurrentLogoPrice] = useState(null);
  const [currentLogos, setCurrentLogos] = useState(null);
  const [logoBGColor, setLogoBGColor] = useState("#CCCCCC");
  const [logoType, setLogoType] = useState(null);
  const [currentDecorations, setCurrentDecorations] = useState(null);
  const [selectedLogos, setSelectedLogos] = useState([]);
  const [logosByPosition, setLogosByPosition] = useState([]);
  const [selectedDecoration, setSelectedDecoration] = useState(null);
  const [updatedLogos, setUpdatedLogos] = useState(null);
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const user = useSelector(getUser);

  const location = useLocation();
  const loginStatus = useSelector(isLoggedIn);
  let navigate = useNavigate();
  const cartItems = useSelector(cart);

  const [qty, setQty] = useState(1);
  const [personalizationFields, setPersonalizationFields] = useState([]);
  const [personalizationValues, setPersonalizationValues] = useState({});
  const [userAddresses, setUserAddresses] = useState([]);
  const [addressSelections, setAddressSelections] = useState({});
  let selectedColor = location.state.colorId;
  let darkBG = "#333333";
  let lightBG = "#CCCCCC";

  // Set initial quantity when quantity pricing data loads
  useEffect(() => {
    if (currentItem?.pricingType === PRICING_TYPES.QUANTITY && quantityPrices && quantityPrices.length > 0) {
      setQty(quantityPrices[0].quantity);
    } else {
      setQty(1);
    }
  }, [currentItem?.pricingType, quantityPrices]);

  const qtyChanged = (event) => {
    setQty(parseInt(event.target.value));
  }
  const gotoLogin = () => {
    navigate("/login");
  }

  const handleAlertClose = () => {
    setShowAlert(false);
  }

  const colorImageClick = async (item) => {
    console.log("ITEM CLIKCED", item);
    setCurrentItem(item);
    setCurrentColor(item.colorName);
    setCurrentSize(0);

    setUpdatedLogos(new Date());
    //setCurrentPrice((item.sizes[0].costSingle2X + currentLogoPrice).toLocaleString(undefined, { maximumFractionDigits: 2 }));
    //updateLogosByPostion(item.logos);
  }

  const colorImageOver = (item) => {
    setImgSrc(resolveImageUrl(item.frontModelImage));

    if (item.logos) {
      setLogoSrc(JSON.parse(item.logos)[0][0]);
    }
    setCurrentColor(item.colorName);
  }

  const colorImageExit = (item) => {
    setImgSrc(resolveImageUrl(currentItem.frontModelImage));
    if (currentItem.logos) setLogoSrc(JSON.parse(currentItem.logos)[0][0]);
    setCurrentColor(currentItem.colorName);
  }

  const sizeClick = (sizeId) => {
    setCurrentSize(sizeId);
  }

  const addSameItem = (item, qty) => {
    let args = { item: item, quantity: qty };
    dispatch(updateItemQuantity(args));
  }

  const addToCartButtonClicked = () => {
    if (!loginStatus) return;

    if (!currentSize) {
      setAlertMessage("Please select a size.");
      setShowAlert(true);
      return;
    }
    console.log("ADD TO CART CURRENT LOGOG", selectedLogos);
    if (!selectedLogos || selectedLogos.length == 0) {
      setAlertMessage("Please select a decoration.");
      setShowAlert(true);
      return;
    }

    // Validate personalization fields
    const personalizationValidation = validatePersonalization();
    if (!personalizationValidation.valid) {
      setAlertMessage(personalizationValidation.message);
      setShowAlert(true);
      return;
    }

    if (currentSubsite.paymentOptions == "itemlimit") {
      // check to make sure limit is not reached
      var cartItemCount = 0;

      for (var j = 0; j < cartItems.length; j++) {
        cartItemCount += cartItems[j].quantity;
      }
      if (cartItemCount + qty > currentSubsiteBalance.balance) {
        setAlertMessage("You have too many items in your cart.  Please remove items before adding any new items.");
        setShowAlert(true);
        dispatch(toggleShowCart(true));
        return;
      }
    }


    let currentProduct = null;
    var i = 0;
    for (i = 0; i < currentItem.sizes.length; i++) {
      if (currentItem.sizes[i].sizeId === currentSize) {
        currentProduct = currentItem.sizes[i].productId;
        break;
      }
    }

    // Prepare personalization data for cart
    const personalization = personalizationFields.map(field => ({
      fieldId: field.id,
      fieldName: field.name,
      fieldType: field.fieldType,
      value: personalizationValues[field.id] || ''
    })).filter(p => p.value); // Only include filled-in values

    var found = false;
    var added = false;
    for (var j = 0; j < cartItems.length; j++) {
      console.log("LOOKING FOR DUPS", cartItems[j], currentItem.sizes[i]);
      if (cartItems[j].product.id === currentItem.sizes[i].productId) {
        // check for decorations
        var sameDecorations = true;
        const cartDecorations = cartItems[j].decorations || [];
        for (var k = 0; k < selectedLogos.length; k++) {
          var found = false;
          for (var l = 0; l < cartDecorations.length; l++) {
            console.log("DECO IDS", cartDecorations[l], selectedLogos[k].id);
            if (cartDecorations[l].id === selectedLogos[k].id) {
              found = true;
              break;
            }
          }
          if (!found) {
            sameDecorations = false;
            break;
          }
        }
        // Also check for same personalization
        const samePersonalization = JSON.stringify(cartItems[j].personalization || []) === JSON.stringify(personalization);

        if (sameDecorations && samePersonalization) {
          console.log("ADD SAME DECO", selectedLogos);
          addSameItem(cartItems[j], cartItems[j].quantity + qty);
          added = true;
        } else {
          console.log("ADD DIFFERENT DECO", selectedLogos);
          dispatch(addItemToOrder({ item: currentItem, quantity: qty, sizeIdx: i, decorations: selectedLogos, personalization }));
          added = true;
        }
      }
    }
    // add i fcart is empty
    if (!added) {
      console.log("ADD NEW", selectedLogos);
      dispatch(addItemToOrder({ item: currentItem, quantity: qty, sizeIdx: i, decorations: selectedLogos, personalization }));
    }

    dispatch(toggleShowCart(true));
  }

  const isSelecedLogo = (logo) => {
    if (!selectedLogos || selectedLogos.length == 0) {
      return false;
    }

    for (var i = 0; i < selectedLogos.length; i++) {
      if (logo.id === selectedLogos[i].id) {
        return true;
      }
    }

    return false;
  }

  const isSetSelected = (setId) => {
    if (!selectedLogos || selectedLogos.length == 0) {
      return false;
    }

    return selectedLogos.some(logo => logo.setId === setId);
  }

  const hasAnySetSelected = () => {
    if (!selectedLogos || selectedLogos.length == 0) {
      return false;
    }

    return selectedLogos.some(logo => logo.setId !== null && logo.setId !== undefined);
  }

  const decoClicked = (logo) => {
    console.log("DECO CLICKED", logo);
    console.log("Current selectedLogos:", selectedLogos);

    // Check if this logo is part of a set
    const isPartOfSet = logo.setId !== null && logo.setId !== undefined;
    console.log("Is part of set:", isPartOfSet, "setId:", logo.setId);

    // Check if currently selected logos include any sets
    const hasSelectedSet = selectedLogos && selectedLogos.some(selectedLogo =>
      selectedLogo.setId !== null && selectedLogo.setId !== undefined
    );
    console.log("Has selected set:", hasSelectedSet);

    if (isPartOfSet) {
      // If clicking a logo from a set
      if (hasSelectedSet) {
        // If already have a set selected, check if it's the same set
        const currentSetId = selectedLogos.find(selectedLogo => selectedLogo.setId)?.setId;
        if (currentSetId === logo.setId) {
          // Same set clicked - check if we can deselect it
          console.log("Same set clicked, checking deselection options");

          // Look for individual logos (non-set logos) to select instead
          const individualDecorations = currentDecorations.filter(d => !d.setId);

          if (individualDecorations.length > 0) {
            // Individual logos available - switch to individual mode
            console.log("Individual logos available, switching to individual mode");
            const newSelectedLogos = [];
            const filledLocations = [];

            for (const decoration of individualDecorations) {
              if (!filledLocations.includes(decoration.deco_location.id)) {
                newSelectedLogos.push(decoration);
                filledLocations.push(decoration.deco_location.id);
              }
            }

            console.log("Switched to individual mode, selected:", newSelectedLogos.map(l => `${l.decoration_logo.decorationName} (${l.deco_location.description})`));
            setSelectedLogos(newSelectedLogos);
            updateLogoPrices(newSelectedLogos);
          } else {
            // No individual logos available, check for other sets
            const setsAvailable = currentDecorations.filter(d => d.setId && d.setId !== currentSetId);
            const uniqueSetIds = [...new Set(setsAvailable.map(d => d.setId))];

            if (uniqueSetIds.length > 0) {
              // Other sets available - switch to different set
              const newSetId = uniqueSetIds[0];
              const newSetLogos = currentDecorations.filter(d => d.setId === newSetId);
              console.log("No individual logos, switched to different set:", newSetId);
              setSelectedLogos(newSetLogos);
              updateLogoPrices(newSetLogos);
            } else {
              // Only one set available and no individual logos - keep current set selected
              console.log("Only one set available with no alternatives, keeping current set selected");
              return; // Don't change selection
            }
          }
        } else {
          // Different set - deselect all current logos and select all logos from the new set
          const allLogosInSet = currentDecorations.filter(decoration => decoration.setId === logo.setId);
          console.log("Different set clicked, deselecting all and selecting new set:", allLogosInSet);
          setSelectedLogos(allLogosInSet);
          updateLogoPrices(allLogosInSet);
        }
      } else {
        // No set currently selected or individual logos selected - deselect all and select this set
        const allLogosInSet = currentDecorations.filter(decoration => decoration.setId === logo.setId);
        console.log("Set clicked, deselecting all individual logos and selecting set:", allLogosInSet);
        setSelectedLogos(allLogosInSet);
        updateLogoPrices(allLogosInSet);
      }
    } else {
      // If clicking an individual logo
      if (hasSelectedSet) {
        // Set is currently selected - deselect ALL set logos and switch to individual mode
        console.log("Individual logo clicked while set selected, deselecting all set logos and switching to individual mode");

        // Start with ONLY the clicked individual logo
        const newSelectedLogos = [logo];
        const filledLocations = [logo.deco_location.id];

        // Add ONLY individual logos from other locations (NO set logos as fallback)
        for (const decoration of currentDecorations) {
          if (!decoration.setId && !filledLocations.includes(decoration.deco_location.id)) {
            newSelectedLogos.push(decoration);
            filledLocations.push(decoration.deco_location.id);
          }
        }

        // DO NOT use set logos as fallback - only individual logos allowed
        console.log("Switched from set to individual mode, selected ONLY individual logos:", newSelectedLogos.map(l => `${l.decoration_logo.decorationName} (${l.deco_location.description})`));
        setSelectedLogos(newSelectedLogos);
        updateLogoPrices(newSelectedLogos);
      } else {
        // Already in individual mode or no selection - handle individual logo selection
        console.log("Individual logo clicked in individual mode");

        if (!selectedLogos || selectedLogos.length == 0) {
          // No current selection - start with this logo and fill other locations
          const newSelectedLogos = [logo];
          const filledLocations = [logo.deco_location.id];

          // Add one logo from each other location (prefer individual logos first)
          for (const decoration of currentDecorations) {
            if (!decoration.setId && !filledLocations.includes(decoration.deco_location.id)) {
              newSelectedLogos.push(decoration);
              filledLocations.push(decoration.deco_location.id);
            }
          }

          // If we still have unfilled locations, use set logos as fallback
          for (const decoration of currentDecorations) {
            if (decoration.setId && !filledLocations.includes(decoration.deco_location.id)) {
              newSelectedLogos.push(decoration);
              filledLocations.push(decoration.deco_location.id);
            }
          }

          console.log("Started individual selection:", newSelectedLogos);
          setSelectedLogos(newSelectedLogos);
          updateLogoPrices(newSelectedLogos);
        } else {
          // Already have individual logos selected - replace logo in same location or add new location
          var newSelectedLogos = [];
          var logoAdded = false;

          for (var i = 0; i < selectedLogos.length; i++) {
            if (selectedLogos[i].deco_location.id === logo.deco_location.id) {
              newSelectedLogos[i] = logo;
              logoAdded = true;
            } else {
              newSelectedLogos[i] = selectedLogos[i];
            }
          }

          if (!logoAdded) {
            newSelectedLogos.push(logo);
          }

          console.log("Updated individual selection:", newSelectedLogos);
          setSelectedLogos(newSelectedLogos);
          updateLogoPrices(newSelectedLogos);
        }
      }
    }
  }

  const formatPantsSize = (sizeName) => {
    var isFour = /^\d{4}$/.test(sizeName);
    if (isFour) {
      return sizeName.substring(0, 2) + "x" + sizeName.substring(2);
    } else {
      return sizeName;
    }
  }

  // Group decorations by setId first, then by location for individual decorations
  const groupDecorationsBySetOrLocation = (decorations) => {
    if (!decorations) return [];

    const setGroups = {};
    const locationGroups = {};
    console.log("DECORATIONS BEFORE GROUPING", decorations);
    // First pass: separate decorations with setId from those without
    decorations.forEach(decoration => {
      if (decoration.setId) {
        // Group by setId (can span multiple locations)
        if (!setGroups[decoration.setId]) {
          setGroups[decoration.setId] = [];
        }
        setGroups[decoration.setId].push(decoration);
      } else {
        // Group by location for individual decorations
        const locationId = decoration.deco_location.id;
        if (!locationGroups[locationId]) {
          locationGroups[locationId] = {
            locationId: locationId,
            locationName: decoration.deco_location.description,
            decorations: []
          };
        }
        locationGroups[locationId].decorations.push(decoration);
      }
    });

    // Convert to array format for rendering
    const result = [];

    // Add set groups first
    Object.keys(setGroups).forEach(setId => {
      const setDecorations = setGroups[setId];
      // Get unique locations for this set
      const locations = [...new Set(setDecorations.map(d => d.deco_location.description))];

      result.push({
        type: 'set',
        setId: setId,
        decorations: setDecorations,
        locationNames: locations,
        title: `Logo Set (${setDecorations.length} logos${locations.length > 1 ? ` across ${locations.length} locations` : ` - ${locations[0]}`})`
      });
    });

    // Add location groups for individual decorations
    Object.values(locationGroups).forEach(locationGroup => {
      if (locationGroup.decorations.length > 0) {
        result.push({
          type: 'location',
          locationId: locationGroup.locationId,
          locationName: locationGroup.locationName,
          decorations: locationGroup.decorations,
          title: locationGroup.locationName
        });
      }
    });
    console.log("DECORATIONS AFTER GROUPING", result);
    return result;
  };

  const updateAllDecorations = (decorations) => {
    // select defaults - prioritize sets, then individual decorations
    console.log("UPDATE ALL DECOS", decorations);
    console.log("DECORATIONS BEFORE GROUPING", decorations);

    if (!decorations || decorations.length === 0) {
      console.log("No decorations available");
      setSelectedLogos([]);
      updateLogoPrices([]);
      setCurrentDecorations([]);
      return;
    }

    var newSelectedLogos = [];

    // First, check if there are any sets
    const setsAvailable = decorations.filter(d => d.setId !== null && d.setId !== undefined);
    const individualsAvailable = decorations.filter(d => d.setId === null || d.setId === undefined);
    const uniqueSetIds = [...new Set(setsAvailable.map(d => d.setId))];

    console.log("Sets available:", setsAvailable.length, "Individual decorations:", individualsAvailable.length);
    console.log("Unique set IDs:", uniqueSetIds);

    if (uniqueSetIds.length > 0) {
      // If sets are available, select the first set (all logos in that set)
      const firstSetId = uniqueSetIds[0];
      newSelectedLogos = decorations.filter(d => d.setId === firstSetId);
      console.log(`Selected set ${firstSetId} with ${newSelectedLogos.length} logos:`, newSelectedLogos.map(l => `${l.decoration_logo.decorationName} (${l.deco_location.description})`));
    } else {
      // No sets available, select one individual decoration per location
      var filledLocations = [];
      for (var i = 0; i < decorations.length; i++) {
        var found = false;
        for (var j = 0; j < filledLocations.length; j++) {
          if (decorations[i].deco_location.id === filledLocations[j]) {
            found = true;
            break;
          }
        }
        if (!found) {
          filledLocations.push(decorations[i].deco_location.id);
          newSelectedLogos.push(decorations[i]);
        }
      }
      console.log(`Selected ${newSelectedLogos.length} individual decorations (one per location):`, newSelectedLogos.map(l => `${l.decoration_logo.decorationName} (${l.deco_location.description})`));
    }

    console.log("Final selected logos:", newSelectedLogos);
    setSelectedLogos(newSelectedLogos);
    updateLogoPrices(newSelectedLogos);
    setCurrentDecorations(decorations);
  }

  const updateLogoPrices = (newSelectedLogos) => {
    var totalPrice = 0;
    for (var i = 0; i < newSelectedLogos.length; i++) {
      totalPrice += newSelectedLogos[i].decoration_logo.price;
    }
    console.log("SELECTED LOGO PRICE", totalPrice);
    setCurrentLogoPrice(totalPrice);
  }

  const updatePrice = (price) => {
    updateLogoPrices(selectedLogos);
  }

  useEffect(() => {
    console.log("PRODUCT DETAILS KEY CHANGED", productId, location.key);
    //loadImages(productId);
    setCurrentItem(null);

    if (!productId || productId === 'undefined') return;
    dispatch(getCatalogItem(productId));
    setLoading(true);
  }, [location.key]);

  let price = 0;

  useEffect(() => {
    var newContent = "";

    if (itemStatus === 'idle') {
      if (!productId || productId === 'undefined') return;
      dispatch(getCatalogItem(productId));
    } else if (itemStatus === 'loading') {
      setLoading(true);
      newContent = <Spinner text="Loading..." />
    } else if (itemStatus === 'succeeded') {
      const firstItem = catalogItem?.items?.[0];
      if (!firstItem) {
        setLoading(false);
        return;
      }

      console.log("PRICING DEBUG - catalogItem:", catalogItem);
      console.log("PRICING DEBUG - pricingType:", firstItem.pricingType);
      console.log("PRICING DEBUG - quantityPrices:", quantityPrices);
      setCurrentItem(firstItem);
      if (firstItem.light == null || !firstItem.light) {
        setLogoBGColor(darkBG);
      } else {
        setLogoBGColor(lightBG);
      }

      var currLogos = [];
      var addedLocs = [];
      var found = false;
      setCurrentSize(0);

      price = firstItem.sizes[0].price;
      let sizes = new Array();

      let currItem = firstItem;
      setCurrentItem(currItem);

      for (var i = 0; i < currItem.sizes.length; i++) {
        var inv = inventory.find(item => item.uniqueKey == currItem.sizes[i].uniqueKey);
        console.log("INV", inv);
        if (inv && inv.quantity == 0) {
          sizes.push(<div><Button style={{ backgroundColor: currentSize === i ? "blue" : "" }} key={i} variant="secondary" data={i} disabled>{formatPantsSize(currItem.sizes[i].sizeName)}<br />{inv?.quantity}</Button></div>);

        } else {
          sizes.push(<div><Button style={{ backgroundColor: currentSize === i ? "blue" : "" }} key={i} variant="secondary" data={i} onClick={(event) => { sizeClick(event); }}>{formatPantsSize(currItem.sizes[i].sizeName)}<br />{inv?.quantity}</Button></div>);
        }
      }


      setLoading(false);

      // Load personalization fields for this style and subsite
      if (firstItem.styleId && currentSubsite && currentSubsite.id) {
        loadPersonalizationFields(firstItem.styleId, currentSubsite.id);
      }
    }
  }, [itemStatus, catalogItem, inventory, quantityPrices, dispatch, currentSubsite]);

  const formatAddress = (addr) => {
    if (!addr) return '';
    return [addr.street, addr.street2, addr.city, addr.state, addr.zipCode]
      .filter(p => p && p.toString().trim().length > 0)
      .join(', ');
  };

  const getProfileValue = (profileFieldName, currentUser, selectedAddress) => {
    if (!currentUser) return '';
    switch (profileFieldName) {
      case 'firstname': return currentUser.firstname || '';
      case 'lastname': return currentUser.lastname || '';
      case 'fullname': return [currentUser.firstname, currentUser.lastname].filter(Boolean).join(' ');
      case 'email': return currentUser.email || '';
      case 'phone': return currentUser.phone || '';
      case 'address': return formatAddress(selectedAddress);
      default: return '';
    }
  };

  const loadPersonalizationFields = async (styleId, subsiteId) => {
    try {
      const response = await fetch(
        process.env.REACT_APP_API_URL + "/personalization/style/" + styleId + "?subsiteId=" + subsiteId
      );
      const fields = await response.json();
      const processedFields = fields.map(f => ({
        ...f,
        options: f.options ? JSON.parse(f.options) : [],
        colorMappings: f.colorMappings || []
      }));
      setPersonalizationFields(processedFields);
      // Initial empty values; pre-fill effect below populates them when user/addresses are ready
      const initialValues = {};
      processedFields.forEach(field => { initialValues[field.id] = ''; });
      setPersonalizationValues(initialValues);
      setAddressSelections({});
    } catch (error) {
      console.error("Error loading personalization fields:", error);
    }
  };

  // Load user addresses when any personalization field is mapped to address
  useEffect(() => {
    const needsAddresses = (personalizationFields || []).some(f => f.userProfileField === 'address');
    if (needsAddresses && user && userAddresses.length === 0) {
      UserService.getAddresses()
        .then(resp => setUserAddresses((resp && resp.data) || []))
        .catch(e => console.error("Error loading user addresses:", e));
    }
  }, [personalizationFields, user]);

  // Apply pre-fills when fields, user, or addresses change
  useEffect(() => {
    if (!personalizationFields || personalizationFields.length === 0) return;
    const newValues = { ...personalizationValues };
    const newAddrSelections = { ...addressSelections };
    let changed = false;
    personalizationFields.forEach(field => {
      if (!field.userProfileField) return;
      if (field.userProfileField === 'address') {
        if (!newAddrSelections[field.id] && userAddresses.length > 0) {
          const defaultAddr = userAddresses[0];
          newAddrSelections[field.id] = defaultAddr.id;
          newValues[field.id] = formatAddress(defaultAddr);
          changed = true;
        }
      } else if (!newValues[field.id]) {
        const v = getProfileValue(field.userProfileField, user, null);
        if (v) {
          newValues[field.id] = v;
          changed = true;
        }
      }
    });
    if (changed) {
      setPersonalizationValues(newValues);
      setAddressSelections(newAddrSelections);
    }
  }, [personalizationFields, user, userAddresses]);

  const handlePersonalizationChange = (fieldId, value) => {
    setPersonalizationValues({
      ...personalizationValues,
      [fieldId]: value
    });
  };

  const resolvePersonalizationDecoColor = (field, productColorId) => {
    if (productColorId != null) {
      const mapping = (field.colorMappings || []).find(m => String(m.colorId) === String(productColorId));
      if (mapping?.deco_color?.colorName) return mapping.deco_color;
      if (mapping?.decoColor?.colorName) return mapping.decoColor;
    }
    return field.deco_color || field.decoColor || null;
  };

  const handleAddressSelectionChange = (fieldId, addressId) => {
    const addr = userAddresses.find(a => String(a.id) === String(addressId));
    setAddressSelections({ ...addressSelections, [fieldId]: addressId });
    setPersonalizationValues({
      ...personalizationValues,
      [fieldId]: formatAddress(addr)
    });
  };

  const validatePersonalization = () => {
    for (const field of personalizationFields) {
      if (field.required && !personalizationValues[field.id]) {
        return { valid: false, message: `Please fill in ${field.name}` };
      }
    }
    return { valid: true };
  };

  return (
    <>
      {(!currentItem || loading) &&
        <div
          style={{
            position: 'absolute', left: '50%', top: '50%',
            transform: 'translate(-50%, -50%)'
          }}
        >
          <Spinner animation="border" variant="primary" />
        </div>
      }
      <Container className="mt-5">
        {currentItem && !loading && (
          <Container className="mt-5" style={{ marginBottom: "150px" }}>
            <Row>
              <Col sm={6}>
                {currentItem ? (
                  <ImageGallery
                    productId={currentItem.productId}
                    selectedDecorations={selectedLogos || []}
                    updateAllDecorations={updateAllDecorations}
                    updatePrice={updatePrice}
                  />
                ) : (
                  <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '400px',
                    backgroundColor: '#f8f9fa',
                    border: '1px solid #dee2e6',
                    borderRadius: '8px'
                  }}>
                    <div style={{ textAlign: 'center' }}>
                      <div className="spinner-border text-primary" role="status">
                        <span className="sr-only">Loading...</span>
                      </div>
                      <div style={{ marginTop: '10px', color: '#6c757d' }}>
                        Loading product...
                      </div>
                    </div>
                  </div>
                )}

              </Col>
              <Col sm={6}>
                <div className="product-content">
                  {currentItem.updatedAt && currentItem.markAsNew == null && (
                    new Date(currentItem.updatedAt).getTime() + ((24 * 60 * 60 * 1000) * (currentSubsite.newDayLimit ? currentSubsite.newDayLimit : 60)) > new Date().getTime() ? (
                      <div className="new-product">New Item</div>
                    ) : (
                      null
                    )
                  )}
                  {userCapability && (
                    <div className="capability-banner">{userCapability.capabilityTitle || userCapability.capabilityName}</div>
                  )}


                  <div className="title">{currentItem.title}</div>
                  {currentItem.productType && (
                    <div style={{
                      display: 'inline-block',
                      marginBottom: '10px',
                      padding: '4px 12px',
                      borderRadius: '4px',
                      fontSize: '0.85em',
                      fontWeight: '500',
                      backgroundColor: currentItem.productType === 'Accessory' ? '#e7f5ff' : '#f3e8ff',
                      color: currentItem.productType === 'Accessory' ? '#17a2b8' : '#6f42c1'
                    }}>
                      {currentItem.productType}
                    </div>
                  )}
                  {currentItem.htmlDescription && (
                    <div className="description" dangerouslySetInnerHTML={{ __html: currentItem.htmlDescription }} />
                  )}
                  {!currentItem.htmlDescription && (
                    <div className="description" dangerouslySetInnerHTML={{ __html: currentItem.description }} />
                  )}
                  <div style={{ fontWeight: 800, color: "#800000" }}>
                    All items are decorated on demand. Decorated items are non-returnable, other than errors on the part of
                    Ignite, manufacturer defects, or decoration errors.
                  </div>

                  <div>
                    {currentItem.specSheet && (
                      currentItem.specSheet.startsWith("http") ? (
                        <a target="_blank" href={`${currentItem.specSheet}`}>Spec Sheet</a>
                      ) : (
                        <a target="_blank" href={`https://www.apparelvideos.com/images/specsheet/pdf/specsheet/${currentItem.specSheet}`}>Spec Sheet</a>
                      )
                    )
                    }
                    <br />
                    {currentItem.measurements && (
                      currentItem.measurements.startsWith("http") ? (
                        <a target="_blank" href={`${currentItem.measurements}`}>Measurements</a>
                      ) : (
                        <a target="_blank" href={`https://www.apparelvideos.com/images/specsheet/pdf/productmeasurements/${currentItem.measurements}`}>Measurements</a>
                      )
                    )}
                    {(currentItem.measurements || currentItem.specSheet) && (
                      <div style={{ fontWeight: 800, color: "#800000" }}>
                        Please reference the Spec Sheet and Measurements above.
                      </div>
                    )
                    }

                  </div>

                  {loginStatus && (currentSubsite.paymentOptions && currentSubsite.paymentOptions != "itemlimit") ? (
                    <>
                      {/* Flat pricing (default) */}
                      {(!currentItem?.pricingType || currentItem?.pricingType === PRICING_TYPES.FLAT) && (
                        <div className="price">${(currentLogoPrice + currentItem.price).toFixed(2)}</div>
                      )}

                      {/* Quantity pricing */}
                      {currentItem?.pricingType === PRICING_TYPES.QUANTITY && quantityPrices && quantityPrices.length > 0 && (
                        <div className="quantity-pricing" style={{ marginBottom: 10 }}>
                          <div style={{ fontWeight: 'bold', marginBottom: 5 }}>Quantity Pricing:</div>
                          {quantityPrices.map((tier, index) => (
                            <div key={index} style={{ fontSize: '0.9em' }}>
                              {tier.quantity} units: ${parseFloat(tier.price).toFixed(2)}
                            </div>
                          ))}
                        </div>
                      )}

                      {/* Bill later pricing */}
                      {currentItem?.pricingType === PRICING_TYPES.BILL_LATER && (
                        <div className="price" style={{ color: '#666', fontStyle: 'italic' }}>
                          Price: Billed Later
                        </div>
                      )}
                    </>
                  ) : null
                  }

                  <div className="color-title">
                    Color: {currentColor ? currentColor : currentItem.colorName}
                  </div>
                  <div className="colors">
                    {(catalogItem?.items || []).map(item => (
                      <div className="color-swatch" style={{ height: 50 }}>

                        {item.squareImageName && (
                          <img src={resolveSwatchUrl(item.squareImageName)} height={50}
                            onClick={(event) => colorImageClick(item)}
                            key={item.colorName}
                            draggable
                          />)}
                        {item.hexColor && !item.squareImageName && (
                          <div style={{ backgroundColor: `${item.hexColor}`, width: 50, height: 50 }} onClick={(event) => colorImageClick(item)}></div>
                        )}

                      </div>
                    ))}
                  </div>
                  <div className="color-title">
                    Decorations:
                  </div>
                  <div style={{ padding: "8px", display: "flex", flexDirection: "column", gap: "8px" }}>
                    {currentDecorations && groupDecorationsBySetOrLocation(currentDecorations).map((group, groupIndex) => {
                      const isSetGroup = group.type === 'set';

                      return (
                        <div key={isSetGroup ? `set-${group.setId}` : `location-${group.locationId}`} style={{
                          border: "1px solid #E0E0E0",
                          borderRadius: "6px",
                          padding: "6px",
                          backgroundColor: "#FAFAFA"
                        }}>
                          <div style={{
                            fontSize: "13px",
                            fontWeight: "600",
                            marginBottom: "6px",
                            color: "#555",
                            display: "flex",
                            alignItems: "center",
                            gap: "6px"
                          }}>
                            {isSetGroup && (
                              <div style={{
                                backgroundColor: "#666",
                                color: "white",
                                borderRadius: "50%",
                                width: "16px",
                                height: "16px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                fontSize: "10px",
                                fontWeight: "bold"
                              }}>
                                S
                              </div>
                            )}
                            {group.title}
                          </div>

                          <div style={{ display: "flex", flexDirection: "row", flexWrap: "wrap", gap: "6px" }}>
                            {group.decorations.map((logo, logoIndex) => {
                              const hasSetSelected = selectedLogos && selectedLogos.some(selectedLogo =>
                                selectedLogo.setId !== null && selectedLogo.setId !== undefined
                              );
                              const isPartOfSet = logo.setId !== null && logo.setId !== undefined;
                              const isIndividualWithSetSelected = hasSetSelected && !isPartOfSet && !isSelecedLogo(logo);

                              return (
                                <div key={`logo-${logo.id}`} onClick={() => decoClicked(logo)} style={{
                                  border: "2px solid",
                                  borderColor: isSelecedLogo(logo) ? "#007bff" : "#DDD",
                                  cursor: "pointer",
                                  display: "inline-block",
                                  opacity: isIndividualWithSetSelected ? 0.7 : 1,
                                  position: "relative",
                                  borderRadius: "4px",
                                  backgroundColor: "white",
                                  transition: "all 0.15s ease",
                                  boxShadow: isSelecedLogo(logo) ? "0 2px 4px rgba(0,123,255,0.3)" : "none"
                                }}>
                                  <div style={{
                                    margin: "2px",
                                    width: "100px",
                                    height: "100px",
                                    backgroundColor: logoBGColor,
                                    borderRadius: "2px",
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    backgroundImage: `url(${currentItem ? resolveSwatchUrl(currentItem.squareImageName) : ""})`,
                                    backgroundSize: "contain"
                                  }}>
                                    <img width="90%" src={apiUrl + logo.decoration_logo.imageUrl} style={{ padding: "2px" }} />
                                  </div>
                                  <div style={{
                                    padding: "2px 4px",
                                    fontSize: "10px",
                                    textAlign: "center",
                                    lineHeight: "1.1",
                                    height: "32px",
                                    overflow: "hidden",
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center"
                                  }}>
                                    <div style={{ fontWeight: "500", marginBottom: "1px", textWrap: "balance" }}>
                                      {logo.decoration_logo.decorationName}
                                    </div>
                                    <div style={{ fontSize: "8px", color: "#666", marginBottom: "1px" }}>
                                      {logo.deco_location.description}
                                    </div>
                                    <div style={{ fontSize: "8px", color: "#888", fontWeight: "500" }}>
                                      {logo.decoration_logo.decoType === "EMBR" ? "Embroidery" :
                                        logo.decoration_logo.decoType === "VYNL" ? "Transfer" :
                                          logo.decoration_logo.decoType === "SCRN" ? "Screen Print" :
                                            logo.decoration_logo.decoType === "KNOCK" ? "Knockdown" :
                                              logo.decoration_logo.decoType}
                                    </div>
                                  </div>
                                  {isIndividualWithSetSelected && (
                                    <div style={{
                                      position: "absolute",
                                      top: "2px",
                                      right: "2px",
                                      backgroundColor: "#007bff",
                                      color: "white",
                                      fontSize: "8px",
                                      fontWeight: "bold",
                                      padding: "1px 3px",
                                      borderRadius: "6px",
                                      lineHeight: "1"
                                    }}>
                                      CLICK
                                    </div>
                                  )}
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                  <div className="color-title">
                    Sizes:
                  </div>
                  <div>
                    <Container>
                      <Row>
                        {currentItem && currentItem.sizes && currentItem.sizes.map(size => {
                          var inv = inventory.find(item => item.uniqueKey == size.uniqueKey);
                          if (!inv || (inv && inv.quantity == 0)) {
                            return (
                              <Col lg="4">
                                <Button
                                  style={{ height: 60, margin: 3, width: "100%", backgroundColor: currentSize === size.sizeId ? "blue" : "" }}
                                  key={size.sizeId}
                                  variant="secondary"
                                  data={size.sizeId}
                                  disabled>
                                  {formatPantsSize(size.sizeName)}<br />OOS
                                </Button>
                              </Col>
                            );
                          } else {
                            if (inv && inv.quantity < 30) {
                              return (
                                <Col lg="4">
                                  <Button style={{ height: 60, margin: 3, width: "100%", backgroundColor: currentSize === size.sizeId ? "blue" : "" }} key={size.sizeId} variant="secondary" data={size.sizeId} onClick={(event) => { sizeClick(size.sizeId); }}>{formatPantsSize(size.sizeName)}<br />Low Stock: {inv?.quantity}</Button>
                                </Col>
                              );

                            } else {

                              return (
                                <Col lg="4">
                                  <Button style={{ height: 60, margin: 3, width: "100%", backgroundColor: currentSize === size.sizeId ? "blue" : "" }} key={size.sizeId} variant="secondary" data={size.sizeId} onClick={(event) => { sizeClick(size.sizeId); }}>{formatPantsSize(size.sizeName)}</Button>
                                </Col>
                              );
                            }
                          }

                        })}
                      </Row>
                    </Container>

                  </div>
                  <div className="quantity">
                    {loginStatus ?
                      <Form.Select aria-label="Quantity" value={qty} onChange={qtyChanged}>
                        {/* Show quantity pricing tiers if available, otherwise default 1-10 */}
                        {currentItem?.pricingType === PRICING_TYPES.QUANTITY && quantityPrices && quantityPrices.length > 0 ? (
                          quantityPrices.map((tier, index) => (
                            <option key={index} value={tier.quantity}>
                              {tier.quantity} units - ${parseFloat(tier.price).toFixed(2)}
                            </option>
                          ))
                        ) : (
                          <>
                            {Array.from({ length: 99 }, (_, i) => (
                              <option key={i+1} value={i+1}>{i+1}</option>
                            ))}
                          </>
                        )}
                      </Form.Select>
                      : null
                    }
                  </div>
                  {/* Personalization Fields */}
                  {personalizationFields && personalizationFields.length > 0 && (
                    <div style={{ marginTop: 15, marginBottom: 15, padding: 10, border: '1px solid #ddd', borderRadius: 8, backgroundColor: '#f9f9f9' }}>
                      <div style={{ fontWeight: 'bold', marginBottom: 10, fontSize: '1.1em' }}>
                        Personalization
                      </div>
                          {personalizationFields.map(field => {
                        const locked = !!field.userProfileField && (field.isEditable === false || field.isEditable === 0);
                        const isAddressField = field.userProfileField === 'address';
                        const decoColor = resolvePersonalizationDecoColor(field, currentItem?.colorId);
                        return (
                          <div key={field.id} style={{ marginBottom: 10 }}>
                            <Form.Label style={{ fontWeight: 500, display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
                              <span>
                                {field.name}
                                {field.required && <span style={{ color: 'red' }}> *</span>}
                                {field.price != null && field.price !== '' && parseFloat(field.price) > 0 && (
                                  <span style={{ color: '#666', fontWeight: 400, fontSize: '0.9em' }}>
                                    {' '}+${parseFloat(field.price).toFixed(2)}
                                  </span>
                                )}
                              </span>
                              {decoColor?.colorName && (
                                <span style={{ color: '#555', fontWeight: 400, fontSize: '0.9em' }}>
                                  Color: {decoColor.colorName}
                                </span>
                              )}
                            </Form.Label>
                            {isAddressField ? (
                              userAddresses.length > 1 ? (
                                <Form.Select
                                  value={addressSelections[field.id] || ''}
                                  onChange={(e) => handleAddressSelectionChange(field.id, e.target.value)}
                                >
                                  {userAddresses.map(a => (
                                    <option key={a.id} value={a.id}>
                                      {formatAddress(a)}
                                    </option>
                                  ))}
                                </Form.Select>
                              ) : (
                                <Form.Control
                                  type="text"
                                  value={personalizationValues[field.id] || ''}
                                  onChange={(e) => handlePersonalizationChange(field.id, e.target.value)}
                                  disabled={locked}
                                  readOnly={locked}
                                />
                              )
                            ) : field.fieldType === 'text' ? (
                              <Form.Control
                                type="text"
                                placeholder={field.placeholder || ''}
                                maxLength={field.maxLength || 100}
                                value={personalizationValues[field.id] || ''}
                                onChange={(e) => handlePersonalizationChange(field.id, e.target.value)}
                                disabled={locked}
                                readOnly={locked}
                              />
                            ) : (
                              <Form.Select
                                value={personalizationValues[field.id] || ''}
                                onChange={(e) => handlePersonalizationChange(field.id, e.target.value)}
                                disabled={locked}
                              >
                                <option value="">Select...</option>
                                {(field.options || []).map((opt, idx) => (
                                  <option key={idx} value={opt}>{opt}</option>
                                ))}
                              </Form.Select>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  )}

                  <div>
                    {loginStatus ?
                      <Button onClick={addToCartButtonClicked}>Add to Cart</Button>
                      :
                      <Button onClick={gotoLogin}>Login or Register to add items to your cart</Button>
                    }
                  </div>
                </div>
              </Col>
            </Row>

          </Container>
        )}
      </Container>
      <Modal show={showAlert} onHide={handleAlertClose}>
        <Modal.Header closeButton>
          <Modal.Title>Alert</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {alertMessage}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleAlertClose}>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    </>

  );
};
export default ProductDetails;